import isEmpty from 'lodash/isEmpty';

import { ReactionDetails, ReactionState, ReactionType } from '../api/types';

/**
 * Update the reactionState both in optimistic and with the final data.
 * Increment the total of reactions based on the action type: 'add' | 'delete' | 'update'
 * Soon we should update the backend API to return a ReactionState directly from the PUT and DELETE api,
 * and only use this method for optimistic update.
 * TODO: CMS-1168 - Once the backend API's are updated to return a ReactionState from the PUT and DELETE, remove the method and all it's implementations.
 * */
export const updateReactionState = (
    prevState: ReactionState,
    reaction: ReactionType,
    /** Can be ignored for optimistic update */
    reactionDetails?: ReactionDetails,
) => {
    const toDelete = prevState.currentUserReactions.includes(reaction);

    const increment = Number(isEmpty(prevState.currentUserReactions) || toDelete);
    const add = toDelete ? -increment : increment;

    const reactionList = [...prevState.reactionCounts.details];

    /** If we're adding a new reaction. And this reaction does not exist in the reaction details list. Add new entry. */
    if (!toDelete && !reactionList.some(({ type }) => type === reaction)) {
        reactionList.push({ type: reaction, count: 0 });
    }

    return {
        currentUserReactions: reactionDetails?.hasUserReacted ?? !toDelete ? [reactionDetails?.type ?? reaction] : [],
        reactionCounts: {
            total: prevState.reactionCounts.total + add,
            details: reactionList.map((detail) => {
                /** If reaction has been added */
                if (detail.type === reaction && !toDelete) {
                    return {
                        type: detail.type,
                        count: reactionDetails?.count ?? detail.count + 1,
                    };
                }
                /** If reaction has been removed */
                if (detail.type === reaction) {
                    return {
                        type: detail.type,
                        count: reactionDetails?.count ?? detail.count - 1,
                    };
                }

                /** If the previous reaction has been removed. Update the details. */
                if (
                    prevState.currentUserReactions.includes(detail.type) &&
                    !prevState.currentUserReactions.includes(reaction)
                ) {
                    return {
                        type: detail.type,
                        count: detail.count - 1,
                    };
                }

                return detail;
            }),
        },
    };
};
